import Vue from 'vue'
import VueRouter from 'vue-router'
//import {publicRoutes} from '@/utils/misc';
import Home from '@/views/Home'
import Login from '@/views/Login';
import Picks from '@/views/Picks';
import Profile from '@/views/Profile';
import ResetForgottenPass from '@/views/ResetForgottenPass';
import SignUp from '@/views/SignUp';
import Modules from '@/views/Modules';
import Submodules from '@/views/Submodules';
import UpSale from '@/views/UpSale';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    props: true,
    children: [
      {
        path: '',
        component: Picks
      },
      {
        path: '/admin',
        //component: Admin
        component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue')
      },
      {
        path: '/admin/services/:service',
        //component: AdminPicks
        component: () => import(/* webpackChunkName: "admin" */ '../components/admin/AdminPicks.vue')
      },
      {
        path: '/admin/links/:service',
        //component: AdminPicks
        component: () => import(/* webpackChunkName: "admin" */ '../components/admin/AdminServiceLinks.vue')
      },
      {
        path: '/profile',
        component: Profile
      },
      {
        path: '/modules',
        component: Modules
      },
      {
        path: '/modules/submodules',
        component: Submodules
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/reset-forgotten-pass',
    component: ResetForgottenPass
  },
  {
    path: '/sign-up',
    component: SignUp
  },
  {
    path: '/us',
    component: UpSale
  },
  {
    path: '/us/:cbfid',
    component: UpSale,
    name: 'upsellSlug'
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL || '/',
  mode: 'history',
  routes,
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
